module.exports = __webpack_public_path__ + "static/6-72302177fe68c53f135f8a259a81a630.jpg";